import { render, staticRenderFns } from "./addBRLModal.vue?vue&type=template&id=46c83942&"
import script from "./addBRLModal.vue?vue&type=script&lang=js&"
export * from "./addBRLModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports